module.exports = __webpack_public_path__ + "10cf64401a3e1658f84d680c7e5d3c9b.svg";